import * as React from 'react'
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'
import type { CalendarEvent } from '../../typings'
import { UpNextRow } from './UpNextRow'

type Props = {
  /** The day's events, already sorted by start. */
  events: CalendarEvent[]
}

/** Day view's right rail: an "Up next" heading over the day's events. */
export function UpNextRail({ events }: Props) {
  const theme = useTheme()

  return (
    <Box
      data-test-id="up-next-rail"
      sx={{
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: '8px',
        padding: '16px',
        boxSizing: 'border-box',
      }}
    >
      <Box
        component="h3"
        sx={{
          margin: 0,
          mb: '10px',
          fontFamily: theme.typography.fontFamily,
          fontSize: '14px',
          fontWeight: 600,
          letterSpacing: '0.06em',
          color: theme.palette.text.primary,
        }}
      >
        Up next
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {events.map((event) => (
          <UpNextRow key={event.id} event={event} />
        ))}
      </Box>
    </Box>
  )
}
